// Search: the full search experience for user 1 + flagged early testers
// (users.universe_access); everyone else sees the teaser.
export const hasSearch = (user: { id: number; universeAccess?: boolean } | null) =>
  !!user && (user.id === 1 || user.universeAccess === true);
